import { connect } from '@seedcloud/stateless'

import { SearchInput } from 'components/common/SearchInput'
import { companyModule, filterQuery$ } from 'modules/legacy-company'

const ConnectedFilterInput = connect(() => ({
  filterQuery: filterQuery$,
}))(FilterInput)

const { filterCompanies } = companyModule

const onChange = (value) => {
  filterCompanies(null, { filterQuery: value })
}

function FilterInput({ filterQuery, containerProps }) {
  return (
    <SearchInput
      value={filterQuery}
      placeholder="Enter company name, abn or email"
      onChange={onChange}
      containerProps={containerProps}
    />
  )
}

export { ConnectedFilterInput as FilterInput }
